import React, { useState } from 'react'
import { useCookies } from 'react-cookie'
import Card from "./Card";

const TUTORIAL_SHOWN_COOKIE = 'tutorialShown'

const Tutorial: React.FC = () => {
  const [cookies, setCookie] = useCookies(['tutorialShown'])
  const [isVisible, setIsVisible] = useState(cookies.tutorialShown !== TUTORIAL_SHOWN_COOKIE)

  if (!isVisible) return null

  const handleClose = () => {
    setCookie('tutorialShown', TUTORIAL_SHOWN_COOKIE, { path: '/' })
    setIsVisible(false)
  }

  return (
    <div className="tutorial">
      <Card hideInstructions={handleClose} />
    </div>
  )
}

export default Tutorial;